import { PrevArrow } from '../../../Icons/SliderArrows';
import { ICarouselArrow } from './carouselArrow.types';

export const CarouselPrevArrow: React.FC<ICarouselArrow> = ({
  classes = '',
  onClick = () => {},
}): JSX.Element => {
  return (
    <div
      className={` bg-gradient-to-r from-[#DDDDDD]/70 to-[#FFFFFF]/10 h-full absolute z-10 top-0 bottom-0 left-0 ${classes}`}
    >
      <div
        className={`border rounded-3xl w-auto p-3 absolute z-10 top-44 left-4 cursor-pointer bg-white inline-block`}
        onClick={onClick}
      >
        <PrevArrow />
      </div>
    </div>
  );
};
